export const createMarkup = (text) => {
  return {__html: `${text}`};
}
